import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextField } from "@material-ui/core";

class AttachOrRemoveFieldDoc extends Component {
  state = {};

  render() {
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">הוספה או הורדה של שדה ממסמך</DialogTitle>
          <DialogContent>
            <div className="inline-block">
              <TextField
                required
                label="קוד"
                className="field-strech"
                onChange={(e) => {
                  this.handleChange(e);
                }}
              />
            </div>
            <div className="mt-40">
              <Button
                className="mr-20 mt-20"
                onClick={() => this.props.addOrRemoveKeyFromDoc(this.state.keyToAddOrRemove, "add")}
                color="secondary"
                variant="contained"
                size="small"
              >
                <i className="material-icons width40">check</i>
              </Button>
              <Button
                className="mr-20 mt-20"
                onClick={() => this.props.addOrRemoveKeyFromDoc(this.state.keyToAddOrRemove, "remove")}
                color="secondary"
                variant="contained"
                size="small"
              >
                <i className="material-icons width40">cancel</i>
              </Button>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cleanAndClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  cleanAndClose = () => {
    this.setState({ keyToAddOrRemove: "" });
    this.props.closePopup();
  };

  handleChange = (e) => {
    this.setState({ keyToAddOrRemove: e.target.value });
  };
}

export default AttachOrRemoveFieldDoc;
